/* tslint:disable */

/**
 * The mode of secutiry:
 *   * NONE
 *   * SIGN
 *   * SIGN_ENCRYPT
 */
type SecurityMode =
  'NONE' |
  'SIGN' |
  'SIGN_ENCRYPT';
namespace SecurityMode {
  export const NONE: SecurityMode = 'NONE';
  export const SIGN: SecurityMode = 'SIGN';
  export const SIGN_ENCRYPT: SecurityMode = 'SIGN_ENCRYPT';
  export function values(): SecurityMode[] {
    return [
      NONE,
      SIGN,
      SIGN_ENCRYPT
    ];
  }
}

export { SecurityMode }